import React from "react";
import Slider from "react-slick";

function ReviewSlider2() {
  const settings = {
    className: "center",
    centerMode: true,
    centerPadding: "60px",
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    rtl: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <Slider {...settings}>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[94%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            VNI has truly transformed my business networking experience. The platform offers endless opportunities to connect, collaborate, and grow with professionals from diverse industries.
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                CMS Negi
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Health & Wellness, Colombia
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Being a VNI member has given me confidence, visibility, and meaningful business relationships. The supportive community and structured approach make it an invaluable experience!
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Rajender Singh
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Construction, United States
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Being a Sr. Admin Executive at VNI is a rewarding experience. The supportive team, growth opportunities, and positive work culture make every day fulfilling. I’m proud to contribute to VNI’s success. 
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Kavita Shakya
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Pest Control, Brazil
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Proud to be a Relationship Manager at VNI—where real connections drive real growth. With new chapters and a mobile/web app launching in 2025, it’s a great time to join and grow your business!
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Ruby Dhiman
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Wellness Coach, Canada
                </p> */}
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Working at VNI has been an amazing experience! The positive work culture, supportive team, and opportunities for growth make it a great place to be. Proud to be part of VNI! 
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Komal Kakkar
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Events, Uganda
                </p> */}
              </div>
            </div>
          </div>

        </div>
        <div>
          <div className="bg-[#EFEFFD] rounded-[20px] p-[30px] max-w-[90%] w-full mx-auto testimomial-box">
            <img src="/assets/home/stars.svg" className="pb-[33px]" alt="" />
            <p className="font-[400] text-[16px] leading-[24px] text-[#00725d] pb-[33px]">
            Being a Digital Marketing Manager at VNI is an incredible experience! I love the creative freedom, innovative strategies, and the opportunity to grow the brand online. The supportive team and dynamic work environment make every day exciting!
            </p>
            <div className="flex items-center gap-[15px]">
              <img style={{height:'50px' , width:'50px'}} src="/assets/pi.png" alt="" />
              <div>
                <h6 className="font-[500] text-[20px] leading-[24px] text-[#00725d]">
                Saba Qureshi
                </h6>
                {/* <p className="font-[400] text-[16px] leading-[24px] text-[#00725d]">
                Events, Uganda
                </p> */}
              </div>
            </div>
          </div>
          
        </div>
      </Slider>
    </>
  );
}

export default ReviewSlider2;
